import { createAction, createRequestTypes, createRequestActions } from './utils';
export const LOAD_ATTRIBUTES = 'LOAD_ATTRIBUTES';
export const FETCH_ATTRIBUTES = 'FETCH_ATTRIBUTES';
export const UPDATE_ATTRIBUTES = 'UPDATE_ATTRIBUTES';
export const UPDATE_DEFAULT_PHONE_COUNTRY_CODE = 'UPDATE_DEFAULT_PHONE_COUNTRY_CODE';
export const UPDATE_PHONE_NUMBER = 'UPDATE_PHONE_NUMBER';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const UPDATE_LANGUAGE_WITH_LOCALE = 'UPDATE_LANGUAGE_WITH_LOCALE';
export const UPDATE_LOCALE = 'UPDATE_LOCALE';
export const UPDATE_LOCALE_WITH_LANGUAGE = 'UPDATE_LOCALE_WITH_LANGUAGE';
export const UPDATE_SIGNATURE_SUCCESS = 'UPDATE_SIGNATURE_SUCCESS';
export const UPDATE_UNSUBSCRIBE_TOGGLE = 'UPDATE_UNSUBSCRIBE_TOGGLE';
export const UPDATE_UNSUBSCRIBE_LINK = 'UPDATE_UNSUBSCRIBE_LINK';
export const UPDATE_DEFAULT_HOME = 'UPDATE_DEFAULT_HOME';
export const FetchAttributesActionTypes = createRequestTypes(FETCH_ATTRIBUTES);
export const UpdateDefaultPhoneCountryCodeActionTypes = createRequestTypes(UPDATE_DEFAULT_PHONE_COUNTRY_CODE);
export const UpdatePhoneNumberActionTypes = createRequestTypes(UPDATE_PHONE_NUMBER);
export const UpdateLanguageWithLocaleActionTypes = createRequestTypes(UPDATE_LANGUAGE_WITH_LOCALE);
UpdateLanguageWithLocaleActionTypes.SHOW_REFRESH_DELAY = `${UPDATE_LANGUAGE_WITH_LOCALE}_SHOW_REFRESH_DELAY`;
export const UpdateLocaleWithLanguageActionTypes = createRequestTypes(UPDATE_LOCALE_WITH_LANGUAGE);
export const UpdateUnsubscribeLinkActionTypes = createRequestTypes(UPDATE_UNSUBSCRIBE_LINK);
export const UpdateDefaultHomeActionTypes = createRequestTypes(UPDATE_DEFAULT_HOME);
export const FetchAttributes = createRequestActions(FetchAttributesActionTypes);
export const UpdateDefaultPhoneCountryCode = createRequestActions(UpdateDefaultPhoneCountryCodeActionTypes);
export const UpdatePhoneNumber = createRequestActions(UpdatePhoneNumberActionTypes);
export const UpdateLanguageWithLocale = createRequestActions(UpdateLanguageWithLocaleActionTypes);
export const UpdateLocaleWithLanguage = createRequestActions(UpdateLocaleWithLanguageActionTypes);
export const UpdateUnsubscribeLink = createRequestActions(UpdateUnsubscribeLinkActionTypes);
export const UpdateDefaultHome = createRequestActions(UpdateDefaultHomeActionTypes);
export const loadAttributes = () => createAction(LOAD_ATTRIBUTES, {
  data: {
    hubless: false
  }
});
export const loadAttributesHubless = () => createAction(LOAD_ATTRIBUTES, {
  data: {
    hubless: true
  }
});
export const updateDefaultPhoneCountryCode = countryCode => createAction(UPDATE_DEFAULT_PHONE_COUNTRY_CODE, {
  data: countryCode
});
export const updatePhoneNumber = phoneNumber => createAction(UPDATE_PHONE_NUMBER, {
  data: phoneNumber
});
export const updateLanguage = language => createAction(UPDATE_LANGUAGE, {
  data: language
});
export const updateLocale = locale => createAction(UPDATE_LOCALE, {
  data: locale
});
export const updateSignatureSuccess = () => createAction(UPDATE_SIGNATURE_SUCCESS);
export const updateUnsubscribeToggle = isToggledOn => createAction(UPDATE_UNSUBSCRIBE_TOGGLE, {
  data: isToggledOn
});
export const updateUnsubscribeLink = link => createAction(UPDATE_UNSUBSCRIBE_LINK, {
  data: link
});
export const showUpdatedLanguageAlert = () => createAction(UpdateLanguageWithLocaleActionTypes.SHOW_REFRESH_DELAY);
export const updateDefaultHome = homeKey => createAction(UPDATE_DEFAULT_HOME, {
  data: homeKey
});